import React, { useState, useEffect , useRef} from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import LookupService from '../../services/LookupService';
import { Dropdown } from "primereact/dropdown";
import ImageUpload from '../../components/ImageUpload';
import { MultiSelect } from "primereact/multiselect";
import { selectStoredPermissions } from '../../stores/permissionsSlice';
import Swal from 'sweetalert2';


const ItemForm = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [appLoader, setAppLoader] = useState(false);
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [categories, setCategories] = useState([]);
  const [branches, setBranches] = useState([]);
  const [addons, setAddons] = useState([]);
  const [tab, setTab] = useState("info");
  const [timings, setTimings] = useState(null);



  const [apiData, setApiData] = useState({
    title: "",
    title_ar: "",
    original_price: "",
    discounted_price: "",
    categories: [],
    addons: [],
    branches: [],
    description: "",
    description_ar: "",
    old_image: '',
  });


  useEffect(() => {
    if (id) {
      getSingleData();
    }
    getCategoriesList();
    getBranchesList();
    // getAddons();
    // getFlavorsList();

  }, [id]);

  const getSingleData = async () => {
    try {
      setAppLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `items/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const item = data.data;
        setApiData({
          title: item.title,
          title_ar: item.title_ar,
          original_price: item.original_price,
          discounted_price: item.discounted_price,
          categories: item.categories,
          pos_id: item.pos_id,
          is_delivery: item.is_delivery,
          is_pickup: item.is_pickup,
          is_web: item.is_web,
          is_app: item.is_app,
          addons: item.addons,
          description: item.description ?? "",
          description_ar: item.description_ar ?? "",
          image: item.image ?? '',
          old_image: item.image ?? '',
          branches: data.disable_branches?.map(item => item.branch_id) || [],
        });
        setTimings(data.timings);
       
      } else {
        toast.error(data.message);
      }
      setAppLoader(false);
    } catch (error) {
      setAppLoader(false);
      console.log(error);
    }
  };



  const getCategoriesList = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `categories-list`,
      });
      const data = response.data;
      if (data.status) {
        setCategories(data.data);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      console.log(error);
    }
  };

  const getBranchesList = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `branches-list`,
      });
      const data = response.data;
      if (data.status) {
        setBranches(data.data);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      console.log(error);
    }
  };




  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleImageChange = (name, file) => {
    setApiData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };


  const submitForm = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const formData = new FormData();
     
      Object.entries(apiData).forEach(([key, value]) => {
          formData.append(key, value);
      });
    

      const response = await ApiService.request({
        method: 'POST',
        url:  `items/createOrUpdate/${id || ''}`,
        data:formData
      });
     
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        LookupService.clear('items-list');
        navigate("/items");
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error("Submit failed:", error);
      setIsLoader(false);
    }
  };

  const handleTimeChange = (index, field, value) => {
    const updatedTimings = [...timings];
    updatedTimings[index][field] = field === "is_off" ? !updatedTimings[index][field] : value;
    setTimings(updatedTimings);
  };

  const updateTiming = async (event) => {
    event.preventDefault();
    setIsLoader(true);

    try {
      
      const response = await ApiService.request({
        method: 'POST',
        url: `items/updateTimings/${id || ''}`,
        data: {'timings':timings},
      });

      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        // navigate('/branches');
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.log(error);
      setIsLoader(false);
    }
  };



  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? "Edit" : "Add New"} Item
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/dashboard" className="text-muted text-hover-primary">
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <a href="/items" className="text-muted text-hover-primary">
                  Items
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button  className={`nav-link fs-6 px-5 ${tab === "info" ? "active" : ""}`}
                            onClick={() => setTab("info")}
                     type="button"> <i className="bi bi-building-fill fs-5"></i> Item Info</button>
                  </li>
                  
                  <li class="nav-item" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "events" ? "active" : ""}`}
                            onClick={() => setTab("events")}
                      type="button" ><i className="bi bi-clock-fill fs-5"></i> Timed Events</button>
                  </li>

                </ul>

            {tab === "info" && (
              <div className="card-body pt-0">
                <form
                  id="kt_modal_new_target_form"
                  encType="multipart/form-data"
                  method="POST"
                  className="form fv-plugins-bootstrap5 fv-plugins-framework"
                  onSubmit={submitForm}
                >
                  <div className="row g-9 my-3">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Title</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Item Title"
                        required
                        value={apiData.title}
                        name="title"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">Title Arabic</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Item Title Arabic"
                        value={apiData.title_ar}
                        name="title_ar"
                        onChange={handleChange}
                      />
                    </div>

                    {/* Branch Select */}
                    {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Branch</label>
                      <Dropdown
                        value={apiData.branch_id}
                        options={branches}
                        optionLabel="name" 
                        optionValue="_id" 
                        onChange={(selectedOption) =>
                          setApiData({ ...apiData, branch_id: selectedOption.value })
                        }
                        placeholder="Select Branch"
                        filter
                        checkmark={true}
                      />
                      
                    </div> */}
              


              
                    {/* Original Price/Mile */}
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">
                        Original Price ({currency})
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="1"
                        className="form-control form-control-solid"
                        placeholder="Item Price"
                        required
                        value={apiData.original_price}
                        onChange={(e) =>
                          setApiData({ ...apiData, original_price: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">
                        Discounted Price ({currency})
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="1"
                        className="form-control form-control-solid"
                        placeholder="Item Discounted Price"
                        value={apiData.discounted_price}
                        onChange={(e) =>
                          setApiData({ ...apiData, discounted_price: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">POS ID</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Item POS ID"
                        value={apiData.pos_id}
                        name="pos_id"
                        onChange={handleChange}
                      />
                    </div>

                
                    {/* Categories */}
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Categories</label>
                        <MultiSelect
                          value={apiData.categories}
                          options={categories}
                          optionLabel="title"
                          optionValue="_id"
                          onChange={(e) => setApiData({ ...apiData, categories: e.value })}
                          placeholder="Select Categories"
                          filter
                          className="form-control"
                        />
                    </div>

                    {/* Addons */}
                    {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className=" fs-6 fw-semibold mb-2">Addons (optional)</label>
                        <MultiSelect
                          value={apiData.addons}
                          options={addons}
                          optionLabel="title"
                          optionValue="_id"
                          onChange={(e) => setApiData({ ...apiData, addons: e.value })}
                          placeholder="Select Addons"
                          filter
                          className="form-control"
                        />
                    </div> */}

                    {/* Disable Branches */}
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className=" fs-6 fw-semibold mb-2">Disable Branches</label>
                        <MultiSelect
                          value={apiData.branches}
                          options={branches}
                          optionLabel="name"
                          optionValue="_id"
                          onChange={(e) => setApiData({ ...apiData, branches: e.value })}
                          placeholder="Select Branches"
                          filter
                          className="form-control"
                        />
                    </div>

                        <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Eligible for Delivery</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox"  
                          checked={apiData.is_delivery === true} onChange={(e) => setApiData({ ...apiData, is_delivery: e.target.checked })}
                            name="is_delivery" id="flexSwitchCheckChecked" />
                      </div>
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Eligible for Pickup</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={apiData.is_pickup === true} onChange={(e) => setApiData({ ...apiData, is_pickup: e.target.checked })}
                           name="is_pickup" id="flexSwitchCheckChecked" />
                      </div>
                    </div>

                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Order Channel (Web)</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={apiData.is_web === true} onChange={(e) => setApiData({ ...apiData, is_web: e.target.checked })}
                           name="is_web" id="flexSwitchCheckChecked" />
                      </div>
                    </div>
                    <div className="col-md-3 fv-row">
                      <label className=" fs-6 fw-semibold mb-2">Order Channel (App)</label>
                      <div className="form-check form-switch mt-2">
                          <input className="form-check-input" type="checkbox" 
                          checked={apiData.is_app === true} onChange={(e) => setApiData({ ...apiData, is_app: e.target.checked })}
                           name="is_app" id="flexSwitchCheckChecked" />
                      </div>
                    </div>
                

                    {/* Item Description */}
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">Item Description</label>
                      <textarea
                        value={apiData.description}
                        rows="3"
                        className="form-control form-control-solid"
                        placeholder="Write Item Description"
                        onChange={(e) =>
                          setApiData({ ...apiData, description: e.target.value })
                        }
                      ></textarea>
                    </div>

                    {/* Description Arabic */}
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">Description Arabic</label>
                      <textarea
                        value={apiData.description_ar}
                        rows="3"
                        className="form-control form-control-solid"
                        placeholder="Write Item Description Arabic"
                        onChange={(e) =>
                          setApiData({ ...apiData, description_ar: e.target.value })
                        }
                      ></textarea>
                    </div>

                    {/* <div className="col-md-12 fv-row fv-plugins-icon-container bg-light rounded  p-3">
                      <label className="fs-3 fw-bold mb-2">Combo
                        <button className="btn btn-base btn-sm mx-3" type="button" onClick={addCombo}> Add Item </button>
                        </label>
                        <div className="table-responsive">
                          <table className="table fs-6 gx-3">
                            <thead>
                              <tr>
                                <th className="w-250px fw-semibold">Item</th>
                                <th className="w-250px fw-semibold">Item Arabic</th>
                                <th className="w-250px fw-semibold">Flavors</th>
                                <th className="w-150px fw-semibold">Quantity</th>
                                <th className="w-150px fw-semibold">Sets/ No. Flavors</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {apiData.combos && apiData.combos.map((combo, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control "
                                      placeholder="Enter Item Title"
                                      required
                                      value={combo?.title}
                                      name="title"
                                      onChange={(e) => handleComboChange(index, e)}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control "
                                      placeholder="Enter Item Title Arabic"
                                      required
                                      value={combo?.title_ar}
                                      name="title_ar"
                                      onChange={(e) => handleComboChange(index, e)}
                                    />
                                  </td>
                                  <td>
                                    <select name="flavor_id" className="form-select" required  value={combo.flavor_id}
                                    onChange={(e) => handleComboChange(index, e)} >
                                        <option value="">Select Flavor</option>
                                      {flavors.map((flvor, index) => (
                                        <option value={flvor._id}>{flvor.title}</option>
                                      ))}
                                    </select>
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control "
                                      placeholder="Total Quantity"
                                      required
                                      value={combo?.quantity}
                                      name="quantity"
                                      onChange={(e) => handleComboChange(index, e)}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control "
                                      placeholder="Sets/No. of Flavors"
                                      required
                                      value={combo?.no_flavors}
                                      name="no_flavors"
                                      onChange={(e) => handleComboChange(index, e)}
                                    />
                                  </td>
                                  <td>
                                    <button 
                                      className="btn btn-danger btn-sm"  type="button"
                                      onClick={() => removeCombo(index)}
                                    >
                                      <i className="bi bi-trash-fill"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        
                    </div> */}

                    {/* Images */}
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-3">
                        <span>Item Image</span>
                      </label>
                      <ImageUpload name="image" onImageChange={handleImageChange} defaultPreviewUrl={apiData.image} />
                      
                    </div>

                  
                  </div>

                  {/* Form Actions */}
                  <div className="row g-9 my-3">
                    <div className="text-center">
                      <button
                        type="button"
                        className="btn btn-light me-3"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>
                      <button type="submit" className="btn btn-base" disabled={isLoader}>
                        {isLoader ? (
                          <Loader size="20" text="Submitting" />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )}
            {tab === "events" && (
              <div class="tab-pane fade show active">
                <div className="table-responsive mt-5 w-lg-75">
                  <form encType="multipart/form-data" method="POST" className="form fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={updateTiming}>

                    <table className="table align-middle table-striped bitem fs-6">
                      <tbody>
                        <tr>
                          <th className="px-3 fw-semibold">Day</th>
                          <th className="px-3 fw-semibold">Start Time</th>
                          <th className="px-3 fw-semibold">End Time</th>
                          <th className="px-3 fw-semibold">Remove</th>
                        </tr>
                        {timings.map((timing, index) => (
                          <tr key={timing.day} className="border">
                            <td className="p-3 fw-bold">
                              {timing.day}
                              <input type="hidden" name="days[]" value={timing.day} />
                            </td>
                            <td>
                              <input
                                type="time"
                                name={`start_time[${timing.day}]`}
                                className="form-control border"
                                value={timing.start_time}
                                onChange={(e) => handleTimeChange(index, "start_time", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="time"
                                name={`end_time[${timing.day}]`}
                                className="form-control border"
                                value={timing.end_time}
                                onChange={(e) => handleTimeChange(index, "end_time", e.target.value)}
                              />
                            </td>
                            <td>
                              <button 
                                type="button" 
                                className="btn btn-sm btn-secondary" 
                                onClick={() => {
                                  handleTimeChange(index, "start_time", "");
                                  handleTimeChange(index, "end_time", "");
                                }}
                              > 
                                <i className="bi bi-trash"></i>  
                              </button>
                            </td>
                          </tr>
                        ))}

                      
                      </tbody>
                    </table>
                    <div className="text-center">
                      <button type="button" className="btn btn-light me-3" onClick={() => navigate('/branches')}>
                        Back
                      </button>
                      <button type="submit" className="btn btn-base" disabled={isLoader || !id}>
                        <span className="indicator-label" hidden={isLoader}>Update</span>
                        {isLoader && <Loader size={20} text="Updating" />}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}


          </div>
        </div>
      </div>

    </div>
  );
};

export default ItemForm;
